<template>
    <div class="number_country_input">
        <label for="numberChose">
            {{ $t("dialog.add_number.number_country") }}
        </label>

        <div class="country-input">
            <vue-tel-input
                ref="telRef"
                v-model="phone"
                @on-input="onInput"
                @country-changed="countryChanged"
                @open="open"
                @close="close"
                @blur="blur"
                :maxlength="13"
                :inputOptions="{
                  showDialCode: true,
                  required: true,
                  id: 'phone-input',
                  attributes: {
                    maxlength: 13
                  }
                }"
                :dropdownOptions="dropdownOptions"
                mode="international"
            />
        </div>
    </div>
</template>

<script setup>
import {ref, onMounted, onUnmounted, nextTick} from 'vue';
import {VueTelInput} from "vue-tel-input";
import {AsYouType} from 'libphonenumber-js'

const phone = ref("");
const dialCode = ref("380");
const parentElem = ref(null);
const isDropdownOpened = ref(false);
const telRef = ref(null)

const dropdownOptions = ref({
    width: "390px",
    showFlags: true,
    showDialCodeInList: true,
});

const open = () => {
    setTimeout(() => {
        let dropdown = parentElem.value.querySelector(".vti__dropdown-list");
        if (!dropdown) {
            return;
        }

        dropdown.style.width = dropdownOptions.value.width;

        let selectedElem = Array.from(
            dropdown.querySelectorAll(".vti__dropdown-item")
        ).find((el) => el.textContent.includes(`+${dialCode.value}`));
        if (selectedElem) {
            selectedElem.scrollIntoView();
            selectedElem.classList.add("selected");
            selectedElem.style.backgroundColor = "#E4E2F4";
        }

        isDropdownOpened.value = true;
        parentElem.value.querySelector("#phone-input").focus();
    }, 10);
};

const close = () => {
    isDropdownOpened.value = false;
};

const blur = () => {
    if (isDropdownOpened.value) {
        nextTick(() => {
            let openBtn = parentElem.value.querySelector(".vti__dropdown");
            if (openBtn.getAttribute('aria-expanded') === 'true') {
                close();
                const event = new Event('close');
                openBtn.dispatchEvent(event);
            }
        });
    }
};

const countryChanged = (event) => {
    dialCode.value = event.dialCode
};

const onInput = (number) => {
    if (!number.startsWith('+')) {
        number = '+' + number
    }

    // Live формат з пробілами
    const formatted = new AsYouType().input(number)
    phone.value = formatted

    // Чисте число для бекенду
    const digits = formatted.replace(/\D/g, '')
    emit('update:userNumber', digits)
};

const onResize = () => {
    let dropdownWidth = parentElem.value.parentElement.offsetWidth - 1 + "px";
    dropdownOptions.value.width = dropdownWidth;
};

const emit = defineEmits(['update:userNumber']);

onMounted(() => {
    parentElem.value = document.getElementById("phone-input").parentElement;
    window.addEventListener("resize", onResize);
    onResize();
    const input = telRef.value?.$el?.querySelector('input')
    if (input) {
        input.setAttribute('maxlength', '20')
    }
});

onUnmounted(() => {
    window.removeEventListener("resize", onResize);
});
</script>

<style lang="scss">
.number-false {
    label,
    input {
        color: var(--danger-second-color);
    }
}

.number_country_input {
    label {
        font-family: Gilroy;
        font-size: 14px;
        font-weight: 600;

        text-transform: uppercase;
    }

    #phone-input {
        padding-top: 18px;
        padding-left: 12px;
        width: 100%;
        height: 50px;

        box-sizing: border-box;
        border: none;
        outline: none;
        border-top-right-radius: 11px;
        border-bottom-right-radius: 11px;
        margin-right: -14px;
        margin-top: 7px;
        font-family: Gilroy;
        font-size: 14px;
        font-weight: 500;

        text-transform: uppercase;

        &::placeholder {
            font-family: Gilroy;
            font-size: 14px;
            font-weight: 500;

            text-transform: uppercase;

            color: var(--text-color);
        }

        // &:-internal-autofill-selected {
        //     background-color: transparent;
        // }
        // &:-webkit-autofill {
        //     color: red;
        //     &:hover,
        //     &:focus,
        //     &:active {
        //         color: green;
        //         box-shadow: none;
        //         background-color: red;
        //         outline: 2px solid var(--primary-color);
        //     }
        // }
    }

    .country-input {
        margin: 10px 0 5px;
        padding: 6px 14px;
        height: 50px;

        display: flex;
        flex-direction: row-reverse;
        align-items: center;

        position: relative;

        box-sizing: border-box;
        border-radius: 11px;
        background-color: var(--block-color);

        input {
            padding: 9px 0;
            height: fit-content;
        }

        .vti__dropdown {
            margin-top: 12px;
        }

        .vue-tel-input {
            width: 100%;
            margin: 0;
            margin-bottom: 7px;
            border: 0;

            &:focus-within {
                box-shadow: none;
            }

            .vti__input {
                background-image: none !important;
                background-color: var(--block-color);
            }

            .vti__dropdown-arrow {
                color: #7a70dfff;
            }
        }

        .vti__dropdown-list {
            bottom: calc(100% + -7px);
            left: -14px;
            background-color: var(--block-color);
            border: none;
            padding-bottom: 10px;
            max-height: 120px;
            height: 120px;

            .vti__dropdown-item {
                padding: 10px;

                font-family: Gilroy;
                font-size: 14px;
                font-weight: 500;

                strong {
                    padding-left: 5px;
                    font-weight: 500;
                }

                &:hover {
                    background-color: #e4e2f4ff;
                }

                &.selected {
                    background-color: #e4e2f4ff;
                }
            }
        }
    }
}
</style>
